import BillingSummaryCSVPreviewColumnsStrategy from './BillingSummaryCSVPreviewColumnsStrategy'

export default function BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy() {}

BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.prototype = new BillingSummaryCSVPreviewColumnsStrategy();

BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.prototype.init = function ()
{
    BillingSummaryCSVPreviewColumnsStrategy.prototype.init.call( this );
    return this;
};

BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.prototype.getNumOfDataColumns = function ()
{
    return 5;
};

BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.prototype.addMainHeaderRowCells = function ( mainHeaderRow )
{
    this.addCell( mainHeaderRow, this.message("report.billing_summary.overall_spent.csv.detailed.overall") );
    this.addCell( mainHeaderRow, this.message("report.billing_summary.overall_spent.csv.detailed.billable") );
    this.addCell( mainHeaderRow, this.message("report.billing_summary.overall_spent.csv.detailed.nonbillable") );

    this.addBillingTypeCells( mainHeaderRow, this.getNumOfDataColumns() - 3 );
};

BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.prototype.addColumnGropingHeaderRowCells = function ( colGroupingRow )
{
    // do nothing
};

BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.prototype.addDataCells = function ( row )
{
    for( var i = 0; i < this.getNumOfDataColumns(); i++ )
        this.addTimeValueCell( row );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/billingsummary/BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.js